<template>
<!-- 工控机模拟器，现无使用，也与接口相差太大。 -->
    <div id="container">
        <!-- 配对与解配 -->
        <el-card class="pair-card">
            <el-button @click="goBack()">返回</el-button>
            <el-tag v-if="isPair">已配对</el-tag>
            <el-tag type="warning" v-if="!isPair">未配对</el-tag>
            <el-input placeholder="" v-model="pairCode" v-if="!isPair">
                <template slot="prepend">配对码</template>
                <el-button slot="append" @click="pair">配对</el-button>
            </el-input>
            <el-input placeholder="" v-model="uuid" :disabled="isPair">
                <template slot="prepend">UUID</template>
                <el-button slot="append" @click="unPair" v-if="isPair">解配</el-button>
            </el-input>
        </el-card>
        <!-- 工厂以及机台信息 -->
        <el-card>
          <el-tag>{{'机台编号:'+machineInfo.number}}</el-tag>
          <el-tag>{{'机台ID:'+machineInfo.id}}</el-tag>
          <el-tag>{{'工厂名:'+machineInfo.factoryName}}</el-tag>
          <el-tag>{{'工厂ID:'+machineInfo.factoryId}}</el-tag>
        </el-card>
        <!-- redis信息显示与心跳相关 -->
        <el-card>
          <el-button @click="setTimer" type="primary">发送心跳</el-button>
          <el-button @click="clearTimer" type="danger">停止发送心跳</el-button>
          <el-button @click="getRedisInfo" type="primary">刷新</el-button>
          <el-input placeholder="" v-model="incrementModel">
                <template slot="prepend">米数增量</template>
                <el-button slot="append" @click="increment = incrementModel*100">确定设置</el-button>
          </el-input>
          <el-input placeholder="" v-model="millisecond">
                <template slot="prepend">心跳毫秒</template>
                <el-button slot="append" @click="resetTimer">重设计时</el-button>
          </el-input>
          <el-tag>{{'总厘米(累计):'+redisInfo.machineMeterTotal}}</el-tag>
          <el-tag>{{'今日厘米数:'+ redisInfo.todayStat.productMeter}}</el-tag>
          <el-tag>{{'redis状态:'+machineStateChinese[redisInfo.stateEnumValueNow]}}</el-tag>
          <el-tag>{{'厘米数增量:'+increment}}</el-tag>
          <el-tag>{{'更新时间(lastUploadTime):'+utils.timestampToTime(redisInfo.lastUploadTime)}}</el-tag>
        </el-card>
        <!-- 心跳状态按钮栏 -->
        <el-card>
            <el-tag>{{'选择状态:'+machineStateChinese[selectMachineState]}}</el-tag>
            <el-button @click="selectMachineState = 0" type="warning">停机</el-button>
            <el-button @click="selectMachineState = 1" type="danger">异常开机</el-button>
            <el-button @click="selectMachineState = 2" type="success">正常生产</el-button>
            <el-button @click="selectMachineState = 3" type="warning">生产停机</el-button>
            <el-button @click="selectMachineState = 4" type="danger">超时停机</el-button>
            <el-button @click="selectMachineState = 5" type="warning">维修请求</el-button>
            <el-button @click="selectMachineState = 6" type="danger">维修请求超时</el-button>
            <el-button @click="selectMachineState = 7" type="warning">维修中</el-button>
            <el-button @click="selectMachineState = 8" type="warning">上盘头请求</el-button>
            <el-button @click="selectMachineState = 9" type="danger">上盘头请求超时</el-button>
            <el-button @click="selectMachineState = 10" type="warning">上盘头中</el-button>
            <el-button @click="selectMachineState = 11" type="warning">穿纱请求</el-button>
            <el-button @click="selectMachineState = 12" type="danger">穿纱请求超时</el-button>
            <el-button @click="selectMachineState = 13" type="warning">穿纱中</el-button>
            <el-button @click="selectMachineState = 14" type="warning">管理员查看</el-button>
            <el-button @click="selectMachineState = 15" type="danger">未知人员登录</el-button>
        </el-card>
        <!-- 工人打卡相关 -->
        <el-card>
          <el-tag>{{'打卡工人:'+workersName}}</el-tag>
          <el-button type="primary" @click="workerLogin">上机打卡</el-button>
          <el-button type="warning" @click="workerLogout">下机打卡</el-button>
          <el-input v-model="workerNumber">
                <template slot="prepend">工人卡号</template>
          </el-input>
          <el-input v-model="workerAction" disabled>
                <template slot="prepend">工人动作</template>
          </el-input>
          <span>选择动作：</span>
          <el-button type="primary" @click="workerAction = 'pantou'">盘头</el-button>
          <el-button type="primary" @click="workerAction = 'chuansha'">穿纱</el-button>
          <el-button type="primary" @click="workerAction = 'dangche'">挡车</el-button>
          <el-button type="primary" @click="workerAction = 'jixiu'">机修</el-button>
        </el-card>
        <!-- 工单相关 -->
        <el-card>
          <el-button type="primary" @click="endWorkOrder">结束工单</el-button>
          <el-input placeholder="" v-model="workOrderNumber">
                <template slot="prepend">工单编号</template>
                <el-button slot="append" @click="confirmWorkOrder">确认工单</el-button>
          </el-input>
        </el-card>
        <!-- 落布相关 -->
        <el-card>
          <el-button type="primary" @click="downCloth">落布</el-button>
          <el-input placeholder="" v-model="frameTotal">
                <template slot="prepend">门幅总数</template>
          </el-input>
          <el-button type="primary" @click="getLastTimeDownClothInfo">重打标签</el-button>
        </el-card>
        <!-- 疵点相关 -->
        <el-card>
          <el-button type="primary" @click="defectRecord">记录疵点</el-button>
          <el-button type="primary" @click="responseDefect">响应疵点</el-button>
          <el-button type="primary" @click="solveDefect">解决疵点</el-button>
          <el-input placeholder="" v-model="defectNumber">
                <template slot="prepend">疵点个数</template>
          </el-input>
          <el-input placeholder="" v-model="frameNumber">
                <template slot="prepend">所在门幅</template>
          </el-input>
        </el-card>
    </div>
</template>

<script>
const machineStateEnum = ['MachineState_Standby', 'MachineState_Abnormal_Running', 'MachineState_Production_Run', 'MachineState_Production_Stop',
  'MachineState_Production_UnusualStop', 'MachineState_Maintenance_Reporting', 'MachineState_Maintenance_ReportTimeout', 'MachineState_Maintenance_Doing',
  'MachineState_Porter_Reporting', 'MachineState_Porter_ReportTimeout', 'MachineState_Porter_Doing', 'MachineState_ThreadingReporting', 'MachineState_Threading_ReporTimeout',
  'MachineState_Threading_Doing', 'MachineState_Manager', 'MachineState_UnknowMan', 'MachineState_Detached']
export default {
  data() {
    return {
      // 传参获取 配对码
      pairCode: '',
      // 传参获取 工控机UUID
      uuid: '',
      // 是否配对
      isPair: false,
      // 通过getMachineInfo()获取 机台信息
      machineInfo: '',
      machineId: '',
      redisInfo: { todayStat: { productMeter: undefined } },
      selectMachineState: 0,
      // 心跳米数的增量 v-model绑定值
      incrementModel: 0,
      // 心跳米数的增量
      increment: 0,
      // 计时器ID
      timerId: undefined,
      millisecond: 3000,
      machineStateChinese: ['停机', '异常开机', '正常生产', '生产停机', '超时停机', '维修请求',
        '维修请求超时', '维修中', '上盘头请求', '上盘头请求超时', '上盘头中', '穿纱请求', '穿纱请求超时',
        '穿纱中', '管理员查看', '未知人员登录', '离线'],
      workersName: '',
      workerNumber: '',
      workerAction: '',
      workOrderNumber: '',
      frameTotal: 1,
      frameNumber: 1,
      defectNumber: 1
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      window.reload()
    },
    initIPC() {
      this.$requestBase({
        url: 'interface/machineIdByUUID',
        method: 'GET',
        params: {
          machineId: this.machineId
        }
      }).then(res => {
        if (res.data === null) {
          this.isPair = false
          this.createPairCode().then(res => {
            this.getMachineInfo(this.pairCode)
          })
        } else {
          this.isPair = true
          this.uuid = res.data
          this.getMachineInfo(this.uuid)
          this.getRedisInfo()
        }
      })
    },
    getMachineInfo(pairCodeOrUuid) {
      this.$request2({
        url: 'MachineState/machineInfoByPairCode',
        method: 'POST',
        data: {
          pairCode: pairCodeOrUuid
        }
      }).then(res => {
        var response = res.data
        response.machineInfo.factoryName = response.factoryName
        this.machineInfo = response.machineInfo
      })
    },
    pair() {
      this.$requestBase({
        url: 'platform/MachineState/pair',
        method: 'POST',
        data: {
          pairCode: this.pairCode,
          pairTime: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.isPair = true
        this.getRedisInfo()
      })
    },
    unPair() {
      this.$requestBase({
        url: 'platform/MachineState/unPair',
        method: 'POST',
        data: {
          factoryId: this.machineInfo.factoryId,
          machineId: this.machineInfo.id,
          unPairTime: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.isPair = false
        this.createPairCode()
      })
    },
    createPairCode() {
      return this.$request2({
        url: `v1/platformweb/paircode/${this.machineId}`,
        method: 'GET'
      }).then(res => {
        this.pairCode = res.data.pairCode
      })
    },
    getRedisInfo() {
      return this.$requestBase({
        url: 'interface/machineStateByUUID',
        method: 'GET',
        params: {
          uuid: this.uuid
        }
      }).then(res => {
        // stateEnumValueNow目前返回为枚举字符串，改为数字即可去掉
        res.data.stateEnumValueNow = this._.indexOf(machineStateEnum, res.data.stateEnumValueNow)
        this.workersName = ''
        res.data.workers.forEach(item => {
          this.workersName = this.workersName + ' ' + item.workerName
        })
        this.redisInfo = res.data
      })
    },
    // 实时心跳请求
    realTimeLiveRequest() {
      this.getRedisInfo().then(res => {
        this.$requestBase({
          url: 'interface/liveDataRecord',
          method: 'POST',
          data: {
            machineStateNow: this.selectMachineState,
            productMeterTotal: this.redisInfo.machineMeterTotal + this.increment,
            uuid: this.uuid,
            time: Date.parse(new Date())
          }
        }).then(res => {
          this.redisInfo.stateEnumValueNow = this.selectMachineState
        })
      })
    },
    setTimer() {
      this.timerId = setInterval(() => {
        this.realTimeLiveRequest()
      }, 3000)
    },
    clearTimer() {
      clearInterval(this.timerId)
      this.timerId = undefined
    },
    resetTimer() {
      this.clearTimer()
      this.timerId = setInterval(() => {
        this.realTimeLiveRequest()
      }, this.millisecond)
    },
    workerLogin() {
      this.$requestBase({
        url: 'interface/login',
        method: 'POST',
        data: {
          action: this.workerAction,
          cardNumber: this.workerNumber,
          factoryId: this.machineInfo.factoryId,
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('工人上机!')
        this.getRedisInfo()
      })
    },
    workerLogout() {
      this.$requestBase({
        url: 'interface/logout',
        method: 'POST',
        data: {
          action: this.workerAction,
          cardNumber: this.workerNumber,
          factoryId: this.machineInfo.factoryId,
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('工人下机!')
        this.getRedisInfo()
      })
    },
    confirmWorkOrder() {
      this.$requestBase({
        url: 'interface/confirmWorkOrder',
        method: 'POST',
        data: {
          productOrderNumber: this.workOrderNumber,
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        console.log('成功！')
        this.$Message.success('确认工单成功！')
      })
    },
    endWorkOrder() {
      this.$requestBase({
        url: 'interface/endWorkOrder',
        method: 'POST',
        data: {
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('结束工单成功！')
      })
    },
    downCloth() {
      this.$requestBase({
        url: 'interface/labelInfoByDownCloth',
        method: 'POST',
        data: {
          frameNumber: this.frameTotal,
          productMeter: 0,
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('落布成功！')
      })
    },
    getLastTimeDownClothInfo() {
      this.$requestBase({
        url: 'interface/labelInfoAgain',
        method: 'POST',
        data: {
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('获取上次的落布信息成功！')
      })
    },
    defectRecord() {
      const requestObj = {
        cameraNumber: 0,
        clothEnd: 0,
        clothStart: 0,
        defectDescriptions: [
          {
            aliasName: '疵点名称',
            centerX: 0,
            centerY: 0,
            classid: 0,
            clothYPosition: 0,
            confidence: 0,
            height: 0,
            indexOfCamera: 0,
            indexOfLarghezza: 0,
            width: 0
          }
        ],
        defectNum: this.defectNumber,
        frameTotal: this.frameNumber,
        time: Date.parse(new Date()),
        uuid: this.uuid
      }
      this.$requestBase({
        url: 'interface/defectRecord',
        method: 'POST',
        data: requestObj
      }).then(res => {
        this.$Message.success('疵点记录成功！')
      })
    },
    responseDefect() {
      this.$requestBase({
        url: 'interface/responseDefect',
        method: 'POST',
        data: {
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('响应疵点成功！')
      })
    },
    solveDefect() {
      this.$requestBase({
        url: 'interface/solveDefect',
        method: 'POST',
        data: {
          time: Date.parse(new Date()),
          uuid: this.uuid
        }
      }).then(res => {
        this.$Message.success('解决疵点成功！')
      })
    }
  },
  created() {
    this.machineId = this.$route.params.machineId
    this.initIPC()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  destroyed () {
    this.clearTimer()
  },
  beforeRouteLeave(to, from, next) {
    this.clearTimer()
    next()
  }
}
</script>

<style scoped lang="scss">
#container {
  display: grid;
  grid-template-columns:50% 50%
}
</style>
